import { createNullableProvideInject } from '@collector/shared-ui'

import { SameTimeIncidentsConfig } from '../configuration'

export const [provideSameTimeIncidentsConfig, injectSameTimeIncidentsConfig] =
  createNullableProvideInject<SameTimeIncidentsConfig>(
    'sameTimeIncidentsConfig',
  )
